import { IStoreKey } from './storeKey';
import { ISubscribable } from './ISubscribable';
import { assign } from '../Utilities';

export class StoreSet {
  private _stores: {
    [key: string]: any;
  };

  constructor() {
    this._stores = {};
  }

  public add<T extends ISubscribable>(key: IStoreKey, value: T): StoreSet {
    this._stores[key.id] = value;
    return this;
  }

  public getStore<T extends ISubscribable>(key: IStoreKey): T {
    return this._stores[key.id];
  }

  public merge(stores: StoreSet) {
    let mergedStoreSet = new StoreSet();

    mergedStoreSet._stores = assign({}, this._stores, stores);

    return mergedStoreSet;
  }
}